import React , {useState} from 'react';
import PropTypes from 'prop-types';

import {Link} from 'react-router-dom';

Sale01.propTypes = {
    
};

function Sale01(props) {

    const [dataBlock] = useState(
        {
            title: 'Start Trading Today',
            desc : 'Join thousands of traders on our secure platform. Get started with crypto trading and earn rewards.',
        }
    )
    return (
        <section className="section-sale-classic">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-8">
                        <div className="sale-content">
                            <h3 className="sale-title">{dataBlock.title}</h3>
                            <p className="sale-desc">{dataBlock.desc}</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="sale-action">
                            <Link to="/register" className="btn-classic">
                                Get Started
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Sale01;